import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SettingsMetaResponse } from '@orion/contracts';
import { api } from '../../../lib/api-client.js';

export function useSettingsQuery<T>(namespace: string) {
  return useQuery({ queryKey: ['admin-settings', namespace], queryFn: () => api.get<T>(`/admin/settings/${namespace}`) });
}

export function useUpdateSettings<T extends Record<string, unknown>>(namespace: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (values: T) => api.put<T>(`/admin/settings/${namespace}`, values),
    onSuccess: (data) => {
      queryClient.setQueryData(['admin-settings', namespace], data);
      queryClient.invalidateQueries({ queryKey: ['admin-settings-meta', namespace] });
    },
  });
}

export function useSettingsMetaQuery(namespace: string) {
  return useQuery({ queryKey: ['admin-settings-meta', namespace], queryFn: () => api.get<SettingsMetaResponse>(`/admin/settings/${namespace}/meta`) });
}

export function useActiveSessionCountQuery() {
  return useQuery({ queryKey: ['admin-security-session-count'], queryFn: () => api.get<{ count: number }>('/admin/settings/security/session-count') });
}

export function useSignOutAllSessions() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.post<{ count: number }>('/admin/settings/security/sign-out-all', {}),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-security-session-count'] }),
  });
}

export function useSendTestEmail() {
  return useMutation({ mutationFn: () => api.post<{ sent: boolean }>('/admin/settings/email/test', {}) });
}
